import { EditCommand } from "./EditCommand";

export abstract class AbstractMoveValueOfArrayCommand<TSource, TValue> extends EditCommand<TSource, { from: number, to: number }> {
  constructor(from: number, to: number) {
    super(
      s => ({ from, to }),
      s => AbstractMoveValueOfArrayCommand.move(this.readArray(s), from, to),
      (s, b) => AbstractMoveValueOfArrayCommand.move(this.readArray(s), b.to, b.from),
    );
  }

  private static move<T>(array: T[], from: number, to: number) {
    const moved = array[from];
    array.splice(from, 1);
    array.splice(to, 0, moved);
  }

  protected abstract readArray(source: TSource): TValue[];
}
